/**
 * Module-level tracking for active Spine and WebView instances.
 * Used by MemoryProfiler to display resource counts.
 */

export interface SpineInstanceData {
	id: string;
	skeletonFile: string;
	playing: boolean;
	isFocused: boolean;
}

/** Active SpineView instance mappings */
export const activeSpineInstances = new Map<string, SpineInstanceData>();

/** Active WebView instance IDs */
export const activeWebViewInstances = new Set<string>();

let instanceCounter = 0;

/** Generate a unique instance ID */
export function generateInstanceId(prefix: string): string {
	return `${prefix}-${++instanceCounter}`;
}
